import React from 'react';
import {MDBCol} from 'mdbreact';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export interface ISectionProps {
  className?: string;
  width?: number;
  flex?: number;
  children?: any;
  loading?: boolean;
}

const Section = ({loading, ...props}: ISectionProps) => {
  return (
    <MDBCol style={{
      minWidth: props.width,
      flex: props.flex || props.width,
      padding: 0,
    }}
            className={props.className}
    >
      {loading ? <SkeletonPlaceHolder style={{width: "100%", height: "100%"}}/> : props.children}
    </MDBCol>
  );
};

Section.defaultProps = {
  loading: false,
};
export default Section;
